import { render, staticRenderFns } from "./changePlanPending.vue?vue&type=template&id=13f536e6"
import script from "./changePlanPending.vue?vue&type=script&lang=js"
export * from "./changePlanPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports